<script lang="ts" setup>
	import {computed} from 'vue';
	import {useFavoriteProductStore} from '@/store/favorite.product.store';

	const props = defineProps<{
		productId: string;
	}>();

	const store = useFavoriteProductStore();

	const isFavorite = computed(() => store.isFavorite(props.productId));

	const toggleFavorite = () => {
		if (!store.isFavorite(props.productId)) {
			store.addToFavorites(props.productId);
		} else {
			store.removeFromFavorites(props.productId);
		}
	};
</script>

<template>
	<button :class="{ active: isFavorite }"
	        class="favorite"
	        @click="toggleFavorite()">

		<svg class="icon-star-small" height="10" width="11">
			<use xlink:href="/assets/images/build/svg-sprite.catalog.min.svg#star-small"></use>
		</svg>
	</button>
</template>
